(function () {

    'use strict';

    angular.module('ApiUtils.growers_dashboard', [])

})();

